import { Header } from "../components/site/Header";
import { Hero } from "../components/site/Hero";
import { BrandMarquee } from "../components/site/BrandMarquee";
import { Products } from "../components/site/Products";
import { HowToBuy } from "../components/site/HowToBuy";
import { Terms } from "../components/site/Terms";
import { FinalCTA } from "../components/site/FinalCTA";
import { Footer } from "../components/site/Footer";

export default function Landing() {
  return (
    <div className="relative bg-[#080a0f] text-white overflow-x-hidden" data-testid="landing-page">
      <Header />
      <main>
        <Hero />
        <BrandMarquee />
        <Products />
        <HowToBuy />
        <Terms />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}
